import { render, staticRenderFns } from "./addCarousel.vue?vue&type=template&id=4ebb9c71&scoped=true&"
import script from "./addCarousel.vue?vue&type=script&lang=js&"
export * from "./addCarousel.vue?vue&type=script&lang=js&"
import style0 from "./addCarousel.vue?vue&type=style&index=0&id=4ebb9c71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebb9c71",
  null
  
)

export default component.exports